<template>
  <a
    href="javascript:void(0)"
    class="btn btn-icon btn-light btn-hover-success btn-sm mx-1"
    v-b-tooltip.hover.top
    :title="$t('TABLES.USER_TOOLTIPS.ACTIVATE')"
    @click="activateUserAlert(user, arrayPos)"
  >
    <span class="svg-icon svg-icon-md svg-icon-success">
      <inline-svg src="media/svg/icons/General/Unlock.svg" />
    </span>
  </a>
</template>

<script>
import { ACTIVATE_USER } from "@/core/services/store/core/user.module";

export default {
  name: "ActivateUser",

  props: ['user', 'arrayPos'],

  methods: {
    activateUserAlert(user, arrayPos) {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.ACTIVATE_CHALLENGE.TITLE")}`,
        text: user.display_name + " " + `${this.$t("SWEETALERTS.ACTIVATE_CHALLENGE.MESSAGE")}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${this.$t("SWEETALERTS.ACTIVATE_CHALLENGE.CONFIRM")}`,
        cancelButtonText: `${this.$t("GENERAL.TEXT.CANCEL")}`,
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = { userId: user.id, arrayPos: arrayPos };
          this.$store.dispatch(ACTIVATE_USER, payload).then(() => {
            this.$swal.fire({
              title: `${this.$t("SWEETALERTS.ACTIVATE_SUCCESS.TITLE")}`,
              text: user.display_name + ' ' + `${this.$t("SWEETALERTS.ACTIVATE_SUCCESS.MESSAGE")}`,
              icon: 'success',
              confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
            })
          })
          .catch(() => {
            this.$swal.fire({
              title: `${this.$t("GENERAL.TEXT.VAGUE_ERROR_TITLE")}`,
              text: `${this.$t("SWEETALERTS.ACTIVATE_FAIL.MESSAGE")}`,
              icon: 'error',
              confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
            })
          })
        }
      })
    },
  }
};
</script>
